// extracted by mini-css-extract-plugin
export default {"listaTarefas":"lista_listaTarefas__DCF7-"};